<template>
  <div class="is-clearfix" style="margin-top: 75px;">
    <div class="container">
      <div class="columns is-flex is-mobile" id="questionnaireForm">
        <div class="column is-3" id="questionnaireLinks">
          <qnav></qnav>
        </div>
        <div style="padding-left: 30px;" class="column is-9">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div style="padding:0 30px">
                <b-notification :active.sync="lockInfo.show" type="is-info" aria-close-label="Close Notification" v-if="!lockInfo.IsLocker && lockInfo.Locker">
                  This section is currently being worked on by {{lockInfo.Locker}}. Please wait until they have finished.
                </b-notification>
              </div>
            </div>
            <div class="column is-12" style="border-bottom: solid 1px #222223;">
              <div class="columns">
                <div class="column is-8">
                  <h2>{{ CountryName + " - " + $store.getters.user.CurrentPeriod }}</h2>
                </div>
                <div class="column is-4">
                  <b-button class="button is-primary is-pulled-right" style="margin-right: 30px;" @click="goToDashboard">{{ $store.getters.currentQuestionnaire.Status == 'Open'? 'Exit without Saving' : 'Exit' }}</b-button>
                </div>
              </div>
            </div>
            <div class="column is-12" style="margin-top: 20px;">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import questionnaireNav from '@/services/components/QuestionnaireNavigation.vue';
  import timeoutModal from '@/services/timeoutModal.vue';
  export default {
    components: {
      qnav: questionnaireNav
    },
    data() {
      return {
        exporting: false,
        lockInfo: {
          show: false,
        }
      }
    },
    watch: {
      "$store.state.idleVue.isIdle": {
        handler(n, o) {
          if (n === true) {
            if (!this.$store.state.idleVue.modalOpen) {
              this.$store.state.idleVue.modalOpen = true;
              this.$timeout.SetCallback((result) => {
                this.$store.state.idleVue.modalOpen = false;
                if (result !== undefined) {
                  this.$router.push(result);
                }
              });
              this.$timeout.Open();
            }
          }
        },
        deep: false
      }
    },
    computed: {
      CountryName() {
        return this.$store.getters["currentQuestionnaire"].CountryName;
      }
    },
    methods: {
      async goToDashboard() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        this.$router.push('/manage/questionnaires');
        this.$store.dispatch('setQuestionnaire', {});
      }
    },
    async created() {

    },
    mounted() {
      var self = this;
    }
  }
</script>
<style>
  #questionnaireForm {
    margin-top: -80px;
    height: -webkit-fill-available;
    height: -moz-available;
    height: fill-available;
    height: 100%;
  }
</style>
